import { render, staticRenderFns } from "./TheProgramsView.vue?vue&type=template&id=50400d45&scoped=true&"
import script from "./TheProgramsView.vue?vue&type=script&lang=js&"
export * from "./TheProgramsView.vue?vue&type=script&lang=js&"
import style0 from "./TheProgramsView.vue?vue&type=style&index=0&id=50400d45&lang=scss&scoped=true&"
import style1 from "./TheProgramsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50400d45",
  null
  
)

export default component.exports